module.exports = __webpack_public_path__ + "static/1344525151.e6004e02.jpg";